export const fmtCOP = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  maximumFractionDigits: 0,
});

export const fmtNum = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 2 });

const DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
const UTC_MIDNIGHT_RE = /^(\d{4})-(\d{2})-(\d{2})T00:00:00(?:\.000)?Z$/;

function dateFromParts(year: number, month: number, day: number): Date {
  // Mediodia local evita que el huso horario desplace el dia al serializar o mostrar.
  return new Date(year, month - 1, day, 12, 0, 0, 0);
}

function parseCalendarLikeDate(value: string): Date | null {
  const match = DATE_ONLY_RE.exec(value) ?? UTC_MIDNIGHT_RE.exec(value);
  if (!match) return null;

  const [, year, month, day] = match;
  return dateFromParts(Number(year), Number(month), Number(day));
}

export function cop(n: number | string | null | undefined): string {
  const v = typeof n === 'string' ? Number(n) : n;
  if (v === null || v === undefined || Number.isNaN(v)) return '—';
  return fmtCOP.format(v);
}

export function num(n: number | string | null | undefined, decimales = 2): string {
  const v = typeof n === 'string' ? Number(n) : n;
  if (v === null || v === undefined || Number.isNaN(v)) return '—';
  return v.toLocaleString('es-CO', { maximumFractionDigits: decimales });
}

export function pct(n: number | string | null | undefined): string {
  const v = typeof n === 'string' ? Number(n) : n;
  if (v === null || v === undefined || Number.isNaN(v)) return '—';
  return `${(v * 100).toFixed(1)}%`;
}

export function toDateValue(value: string | Date | null | undefined): Date | null {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

  const calendarDate = parseCalendarLikeDate(value);
  if (calendarDate) return calendarDate;

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function fecha(s: string | Date | null | undefined): string {
  const d = toDateValue(s);
  if (!d) return '—';
  return d.toLocaleDateString('es-CO', { year: 'numeric', month: '2-digit', day: '2-digit' });
}

export function hoy(): string {
  const d = new Date();
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
